import { ImageList, ImageListItem, useMediaQuery } from "@mui/material";
import { ConversationInfo, ConversationMessage } from "../../../redux/conversation/conversationSlice";
import React, { useState } from "react";
import { assertThumbnailUrl } from "../../../redux/common";
import { MessageTile } from "./MessageTile";
import { PRIZA_THEME } from "../../..";
import { ModalImageDetail } from "../../base/image/ModalImageDetail";
import { ImageInfo } from "../../../redux/image/imageSlice";

interface MessageImageListProps {
    conversation: ConversationInfo;
    messages: ConversationMessage[];
    schoolId?: string;
}

export const MessageImageListTile = (props: MessageImageListProps) => {
    const isSm = useMediaQuery(PRIZA_THEME.breakpoints.up("sm"));
    const isMd = useMediaQuery(PRIZA_THEME.breakpoints.up("md"));
    const isLg = useMediaQuery(PRIZA_THEME.breakpoints.up("lg"));
    const isXl = useMediaQuery(PRIZA_THEME.breakpoints.up("xl"));
    const [imagePosition, setImagePosition] = useState(undefined as number | undefined);

    const columnCount =
        isXl ? 12 :
        isMd ? 10 :
        isLg ? 8 :
        isSm ? 6 : 3;

    const imagesEl = [] as React.ReactNode[];
    props.messages.forEach((image, i) => {
        const url = assertThumbnailUrl(`ml:${image.contentId}`);
        imagesEl.push(
            <ImageListItem key={image.id} sx={{ maxHeight: 80 }}>
                <img src={url} onClick={(/* event */) => setImagePosition(i)}/>
            </ImageListItem>
        );
    });

    const modal = (imagePosition != undefined)
        ? <ModalImageDetail
            avatar={undefined}
            open={ imagePosition != undefined }
            close={() => setImagePosition(undefined)}
            previous= {imagePosition > 0 ? () => setImagePosition(imagePosition - 1) : undefined}
            next= {imagePosition < props.messages.length - 1 ? () => setImagePosition(imagePosition + 1) : undefined}
            image={
                {
                    id: props.messages[imagePosition].contentId,
                    createdAt: props.messages[imagePosition].processed,
                } as ImageInfo
            }
            schoolId={props.schoolId}
        />
        : <></>;

    return <>
        <MessageTile key={props.messages[0].id} conversation={props.conversation} message={props.messages[0]}
            content={
                <ImageList variant="quilted" cols={columnCount} sx={{ p: 0, m: 0, mb: 0 }} gap={8}>
                    {imagesEl}
                </ImageList>
            }
        />
        {modal}
    </>;

};